import axios from "axios";
// Get base URL from .env file
const baseUrl = process.env.REACT_APP_API_URL;
/**
 * Fetch product reviews by productId.
 * @param {string|number} productId - The product ID.
 * @returns {Promise<Array>} List of reviews.
 */
export const getProductReviews = async (productId) => {
  const response = await axios.get(
    `${baseUrl}/api/ColtecProduct/GetProductReviewsById?ProductId=${productId}`
  );
  return response.data;
};
